<template>
  <div id="app" class="sa-wrapper">
    <div class="sa-container">
      <navigation />
      <router-view></router-view>
      <transition name="slide-left">
        <div
          v-if="alertMessage.msg"
          class="sa-alert sa-alert-fixed"
          :class="alertMessage.class"
        >
          {{ alertMessage.msg }}
          <i class="icon-close sa-a-close" v-on:click="resetAlertMessage()"></i>
        </div>
      </transition>
      <force-update :data="updateData" v-show="updateApp" />
    </div>
    <footer-bar />
  </div>
</template>
<script>
import NavigationVue from "../components/common/Navigation.vue";
import ForceUpdate from "../components/common/ForceUpdate.vue";
import FooterVue from "../components/common/Footer.vue";
import { oh_url, com_url, version } from "../../config/endpoints";
import { mapState } from "vuex";
export default {
  name: "App",
  watch: {
    alertMessage: {
      deep: true,
      immediate: true,
      handler() {
        if (this.alertMessage.msg) {
          setTimeout(() => {
            this.$store.dispatch("SET_ALERTMESSAGE", { msg: "", class: "" });
          }, 5000);
        }
      },
    },
  },
  computed: mapState(["alertMessage"]),
  components: {
    navigation: NavigationVue,
    "footer-bar": FooterVue,
    "force-update": ForceUpdate,
  },
  data() {
    return {
      updateApp: false,
      updateData: {},
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    resetAlertMessage() {
      this.$store.dispatch("SET_ALERTMESSAGE", { msg: "", class: "" });
    },
  },
  mounted() {
    this.toggleBodyClass("addClass", "sa-bg-blue");
    let _self = this;
    _self.$store
      .dispatch("httpPost", {
        uri: `${oh_url}/general/getStaticData`,
        body: {
          mtype: [],
        },
      })
      .then((response) => {
        if ((response.status = 1000)) {
          _self.updateData = response.data.prodesktop;
          if (_self.updateData.versionnumber_desktop != version) {
            _self.updateApp = true;
          }else {
            _self.updateApp = false;
          }
        }
      })
      .catch((e) => {
        // console.log(e);
      });
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "sa-bg-blue");
  },
};
</script>